import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import {
  CommonDashModel,
  Environment,
  MagArtModel,
  MagArtSottoscorta_TableModel,
  MagazziniArticoli,
  MagazziniArticoliUdM,
  ModelBoolNum,
  ModelNumDecimal,
  ModelNumNum,
  ModelNumStrColor,
} from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class MagazziniArticoliService extends CrudGenericsService<MagazziniArticoli, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MagazziniArticoli`);
    this.base = `${env.apiUrl}/api/MagazziniArticoli/`;
  }

  GetSingle_ByArtByPosi(id_art: number, id_set_loc: number): Observable<MagazziniArticoliUdM> {
    const u = `${this.base}GetSingle_ByArtByPosi?id_art=${id_art}&id_set_loc=${id_set_loc}`;
    return this.http.get<MagazziniArticoliUdM>(u);
  }

  GetMagArtGiacenze_byArt(id): Observable<MagArtModel[]> {
    const u = `${this.base}GetMagArtGiacenze_byArt?id=${id}`;
    return this.http.get<MagArtModel[]>(u);
  }
  // tabella
  GetMagArtSottoscorta_TableModel(): Observable<MagArtSottoscorta_TableModel[]> {
    const u = `${this.base}GetMagArtSottoscorta_TableModel`;
    return this.http.get<MagArtSottoscorta_TableModel[]>(u);
  }

  // fast  aggiorna la scorta minima
  UpdMagArt_QtaScortaMinima(id: number, qtaScortaMinima: number) {
    const model: ModelNumDecimal = { Value: id, Decimal: qtaScortaMinima };
    const u = `${this.base}UpdMagArt_QtaScortaMinima`;
    return this.http.post(u, model);
  }
  // fast  aggiorna l unita di misura
  UpdMagArt_Udm(id: number, id_udm: number) {
    const model: ModelNumNum = { Value: id, Number: id_udm };
    const u = `${this.base}UpdMagArt_Udm`;
    return this.http.post(u, model);
  }
  // fast  aggiorna l unita di misura
  UpdMagArt_Disattivo(id: number, disattivo: boolean) {
    const model: ModelBoolNum = { Value: id, Bool: disattivo };
    const u = `${this.base}UpdMagArt_Disattivo`;
    return this.http.post(u, model);
  }

  // icona colore valore per criticita
  GetCriticitaIcon_byMagArt(id: number): Observable<ModelNumStrColor> {
    const u = `${this.base}GetCriticitaIcon_byMagArt?id=${id}`;
    return this.http.get<ModelNumStrColor>(u);
  }
  // web dashboard

  DashBoard_MagArt(): Observable<CommonDashModel> {
    const u = `${this.base}DashBoard_MagArt`;
    return this.http.get<CommonDashModel>(u);
  }
}
